import React from "react";
import { Feedback } from "../../../Models/Feedback";
import styles from "../../../Styles/FeedbackList.module.scss";
import FeedbackStateChangeButtons from "../FeedbackButtons/FeedbackStateChangeButtons";
import MoveFeedbackModal from "../MoveFeedbackModal";
import { IconButton } from "../../../../Layout";
import { FeedbackHistoryModal } from "../../FeedbackHistory/FeedbackHistoryModal";
import { FeedbackState } from "../../..";
import { LoadingDisplay } from "../../../../Common";

type Props = {
  feedback: Feedback;
  areTransitionsLoaded?: boolean;
  onStateChange: (feedbackCode: string) => void;
  onMove: (feedback: Feedback) => void;
};

export const FeedbackListButtons: React.FC<Props> = props => {
  const areTransitionsLoaded =
    props.areTransitionsLoaded == null ? true : props.areTransitionsLoaded;

  return (
    <span className={styles.buttons}>
      {areTransitionsLoaded && (
        <FeedbackStateChangeButtons feedback={props.feedback} onStateChange={props.onStateChange} />
      )}
      {!areTransitionsLoaded && <LoadingDisplay />}
    </span>
  );
};

export default FeedbackListButtons;
